import { accountingSystemProvider } from 'shared';

import { useGetSubscriptionMetadata } from '../hooks/useGetSubscription';
import { Notification } from '../../common/Atoms/Notification';
import { useGetSelectedOrganisation } from '../hooks/useGetSelectedOrganisation';
import { Button } from '../../common/Atoms/Button';
import { env } from '../../common/lib/env';

export function NotificationArea() {
  const currentOrg = useGetSelectedOrganisation();
  const { subscriptionMetadata } = useGetSubscriptionMetadata();

  if (!currentOrg) return null;

  if (currentOrg?.connected) return null;

  if (!subscriptionMetadata) return null;

  const connectSlug = accountingSystemProvider(currentOrg)?.connectSlug;

  return (
    <>
      <div className={ `pb-4` }>
        <Notification
          type={ `error` }
          title={ `Attention` }
          buttons={ connectSlug && (
            <a
              href={ `${env.apiUrl}/connect/${connectSlug}` }
            >
              <Button
                color={ `orangeOutline` }
              >
                { `Reconnect` }
              </Button>
            </a>
          ) }
        >
          { `Organisation is not connected` }
        </Notification>
      </div>
    </>
  );
}
